import { FormControl, Select } from '@material-ui/core';
import styled from 'styled-components';

export const HearlandForm = styled.form`
  margin-top: 20px;
`

export const CardFieldGroup = styled.div`
  align-items: stretch;
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const CardField = styled.div`
  display: flex;
  height: 44px;
  width: 100%;

  iframe {
    width: 100% !important;
  }
`;

const topField = {
  'border-top-right-radius': '6px',
  'border-top-left-radius': '6px',
}

export const FormStyles = {
  'iframe': {
    width: "100%",
  },
  '#secure-payment-field-wrapper': {
    "margin-bottom": "10px",
  },
  '#secure-payment-field': {
    "border": "#e0e0e0 1px solid",
    "padding": "8px 12px",
    "width": "100%",
  },
  '.card-holder-name': topField,
  '.account-number': {
    'border-top-right-radius': '6px',
    'border-top-left-radius': '6px',
  },
  '.card-cvv': {
    'border-bottom-right-radius': '6px',
  },
  '.card-expiration': {
    'border-bottom-left-radius': '6px',
  },
  '.submit': {
    'background-color': '#458E87',
    color: '#eee',
    cursor: 'pointer',
    'border-radius': '6px',
    'box-shadow': 'inset 0 0 0 1px rgba(50, 50, 93, 0.1), 0 2px 5px 0 rgba(50, 50, 93, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.07)',
    border: '0',
    height: '40px',
    width: '100%',
    'font-size': '16px',
    'font-weight': '600',
    'margin-top': '40px',
  },
  '.submit:disabled': {
    'background-color': '#999a9a',
  }    
};

export const FormControlSelectWrapper = styled(FormControl)`
  border-radius: 0;
  display: block;
  margin-bottom: 10px !important;
  width: 100%;
`

export const FormSelectCheckType= styled(Select)`
  border-radius: 0 !important;  
  border-bottom-left-radius: 10px !important;
  border: #e0e0e0 1px solid;
  height: 32px;
  padding: 0 5px;
  width: 100%;
`

export const FormSelectAccountType= styled(Select)`
  border-radius: 0 !important;  
  border-bottom-right-radius: 10px !important;
  border: #e0e0e0 1px solid;
  height: 32px;
  padding: 0 5px;
  width: 100%;
`